<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-31 09:16:39
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-12 14:57:40
 * @FilePath: /chaoyongtuan/src/components/tableCells/goodsTagCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="goodsTagCell">
		<div class="box">
			<p class="mb-6" v-for="(item, index) in showTagArr" :key="index">
				<el-tag>{{ item.tag_name }}</el-tag>
			</p>
			<el-popover placement="bottom" max-width="500" trigger="hover" :key="tagArr.length">
				<el-tag class="ml-4" v-for="(item, index) in hideTagArr" :key="index">{{ item.tag_name }}</el-tag>
				<el-tag slot="reference" v-if="hideTagArr.length">+{{ hideTagArr.length }}</el-tag>
			</el-popover>
			<div></div>
			<div @click="tagDialog" v-if="isShowEdit" class="flex flex-align-center mt-6 fz-12 edit-tag pointer">
				<i class="el-icon-edit"></i>
				<span class="ml-4">编辑标签</span>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
	props: {
		editTag: {
			type: Boolean,
			default: true,
		},
		auth: {
			type: String,
			default: '',
		},
	},
	computed: {
		tagArr({ row }) {
			return row.tag_arr || [];
		},
		showTagArr({ tagArr }) {
			return tagArr.length > 2 ? tagArr.slice(0, 3) : tagArr;
		},
		hideTagArr({ tagArr }) {
			return tagArr.length > 2 ? tagArr.slice(3) : [];
		},
		isShowEdit({ editTag, auth, column }) {
			let value = column['auth'] ? column['auth'] : auth;
			return this.$auth.hasPermi(value) && editTag;
		},
	},
	data() {
		return {};
	},
	methods: {
		tagDialog() {
			this.row.operations.tagDialog(this.row);
		},
	},
};
</script>
<style lang="less" scoped>
.edit-tag {
	display: inline-block;
	background-color: #f7f8fa;
	border-radius: 2px;
	padding: 0px 4px;
}
</style>
